"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnChat = void 0;
const core = __importStar(require("../../../../core"));
const ReturnChatStatus_1 = require("./ReturnChatStatus");
const ReturnConfigSpec_1 = require("./ReturnConfigSpec");
exports.ReturnChat = core.serialization.object({
    id: core.serialization.string(),
    chatGroupId: core.serialization.property("chat_group_id", core.serialization.string()),
    status: ReturnChatStatus_1.ReturnChatStatus,
    startTimestamp: core.serialization.property("start_timestamp", core.serialization.number()),
    endTimestamp: core.serialization.property("end_timestamp", core.serialization.number().optional()),
    eventCount: core.serialization.property("event_count", core.serialization.number().optional()),
    metadata: core.serialization.string().optional(),
    config: ReturnConfigSpec_1.ReturnConfigSpec.optional(),
});
